/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';
import { dependentKeyCompat } from '@ember/object/compat';
import { type Registry as Services, service } from '@ember/service';
import dayjs from 'dayjs';
import { EXTRAPOLATED_DATA } from 'frontend-utils/utils/constants/constant-values';
import GeneralTooltipsTooltipOtb from 'lumen/components/general/tooltips/tooltip-otb';

export default class GeneralTooltipsTooltipOtbPace extends GeneralTooltipsTooltipOtb {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare intl: Services['intl'];

  @dependentKeyCompat
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasHistoricPace() {
    return this.hotelAndMarketService.hotel?.pmsHasHistoricPace;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasPaceData() {
    return this.hasHistoricPace || !this.isExtraPolated;
  }

  @computed('args.occupancy.message')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isExtraPolated() {
    return this.args.occupancy?.message === EXTRAPOLATED_DATA;
  }

  // eslint-disable-next-line ember/use-brace-expansion
  @computed('args.occupancy.period.leadtime', 'args.{dayMoment,extractDate}')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get leadtimeText() {
    // @ts-expect-error: Incorrect type
    if (!this.args.extractDate) {
      return '';
    }
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const formattedExtractDate = this.args.extractDate.format('dddd LL');
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const leadtime = this.args.dayMoment.diff(this.args.extractDate, 'days');
    return `${this.intl.t('rates.leadtime')} ${leadtime} (${formattedExtractDate})`;
  }

  @dependentKeyCompat
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get pmsIntegrationDate() {
    return this.hotelAndMarketService.hotel?.pmsIntegrationDate;
  }

  @computed(
    // eslint-disable-next-line ember/use-brace-expansion
    'args.pmsIntegrationDateInCurrentRange',
    'args.referenceOccupancy.message',
    'hasHistoricPace',
    'pmsIntegrationDate',
  )
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get referenceRowLabel() {
    const lastYearText = this.intl.t('general.last_year');

    // Check if the mapped LY date still contained extrapolated data (= last year date is before the integration date)
    const lastYearDataIsExtraPolated =
      this.args.referenceOccupancy?.message === EXTRAPOLATED_DATA;
    if (!this.hasHistoricPace && lastYearDataIsExtraPolated) {
      // If the PMS integration date is in range: show "Last year final"
      // @ts-expect-error: Incorrect type
      if (this.args.pmsIntegrationDateInCurrentRange) {
        return this.intl.t('pace.last_year_final', { lastYear: lastYearText });
      }
      // If the PMS integration date is not in range: show "Last year as of integration date"
      return this.intl.t('pace.as_of_integration_date', {
        lastYear: lastYearText,
        date: dayjs(this.pmsIntegrationDate).format('L'),
      });
    }
    return lastYearText;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showTooltipContent() {
    return this.hasPaceData;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get title() {
    if (!this.hasPaceData) {
      return this.intl.t('pace.integration_started', {
        date: dayjs(this.pmsIntegrationDate).format('LL'),
      });
    }

    return this.leadtimeText;
  }
}
